import {toFixedWithCommas} from "../../../utils/number-util";
import dayjs from "dayjs";
import HoverIcon from '@components/HoverIcon'
import { Link } from "react-router-dom";
import Detail from "../PaymentCheckOut/Deatil";
import DeatilIn from "../PaymentCheckIn/components/Deatil";

function getColumns(){
    return [
        {
            cnTitle: '单据号',
            cnTitleId: 'DanJuHao',
            width: 150,
            fixed: "left",
            dataIndex: 'code',
            render: (code, record, index) => (
                <div>{code|| "-"}</div>
            ),
        },
        {
            cnTitle: '客户',
            cnTitleId: 'KeHu',
            dataIndex: 'buyerName',
            render: (buyerName, record, index) => (
                <Link className="num" to={`/customer/detail?id=${record.buyerId}`}>{record.buyerCode}</Link>
            ),
        },
        {
            cnTitle: '汇款日期',
            cnTitleId: 'HuiKuanRiQi',
            dataIndex: 'moneyOutTime',
            render: (moneyOutTime, record, index) => (
                <div key={index}>
                        {record.moneyOutTime
                            ? dayjs(record.moneyOutTime).format("YYYY-MM-DD")
                            : "-"}
                    </div>
            ),
        },
        {
            cnTitle: '扣减金额',
            cnTitleId: 'KouJianJinE',
            dataIndex: 'moneyOut',
            type:'money',
            showSymbol:'currencySymbol',
        },
        {
            cnTitle: '登记人',
            cnTitleId: 'DengJiRen',
            dataIndex: 'createBy',
            render: (createBy, record, index) => (
                <span>{createBy || "-"}</span>
            ),
        },
        {
            cnTitle: '登记日期',
            cnTitleId: 'DengJiRiQi',
            dataIndex: 'createTime',
            width: 300,
            render: (createTime, record, index) => (
                <div key={index}>
                        {record.createTime
                            ? dayjs(record.createTime).format("YYYY-MM-DD")
                            : "-"}
                    </div>
            ),
        },
        {
            cnTitle: '操作',
            cnTitleId: 'CaoZuo',
            width: 110,
            dataIndex: 'options',
            fixed: "right",
            render: (options, record, index) => (
                <Detail model={record}>
                    <HoverIcon inactiveIcon="icon-xiangqing"
                               activeIcon="icon-xiangqing-1"></HoverIcon>
                </Detail>
            ),
        },
    ];
}

// 来款登记栏目
function getColumnsIn(){
    return [
        {
            cnTitle: '单据号',
            cnTitleId: 'DanJuHao',
            width: 180,
            fixed: "left",
            dataIndex: 'remittanceCode',
            render: (remittanceCode, record, index) => (
                <div>{remittanceCode|| "-"}</div>
            ),
        },
        {
            cnTitle: '客户',
            cnTitleId: 'KeHu',
            dataIndex: 'buyerName',
            render: (buyerName, record, index) => (
                <Link className="num" to={`/customer/detail?id=${record.buyerId}`}>{record.buyerCode}</Link>
            ),
        },
        {
            cnTitle: '到款日期',
            cnTitleId: 'DaoKuanRiQi',
            dataIndex: 'moneyInTime',
            render: (moneyInTime, record, index) => (
                <div key={index}>
                    {record.moneyInTime
                        ? dayjs(record.moneyInTime).format("YYYY-MM-DD")
                        : "-"}
                </div>
            ),
        },
        {
            cnTitle: '实际到款金额',
            cnTitleId: 'ShiJiDaoZhangJinE',
            dataIndex: 'moneyIn',
            type:'money',
            showSymbol:'currencySymbol',
            // render: (moneyOut, record, index) => (
            //     <span>{record.currencySymbol} {record.moneyOut?toFixedWithCommas(record.moneyOut,2):'-'}</span>
            // ),
        },
        {
            cnTitle: '登记人',
            cnTitleId: 'DengJiRen',
            dataIndex: 'createByName',
            render: (createByName, record, index) => <span>{createByName || "-"}</span>,
        },
        {
            cnTitle: '登记日期',
            cnTitleId: 'DengJiRiQi',
            dataIndex: 'createTime',
            width: 300,
            render: (createTime, record, index) => (
                <div key={index}>
                    {record.createTime
                        ? dayjs(record.createTime).format("YYYY-MM-DD")
                        : "-"}
                </div>
            ),
        },
        {
            cnTitle: '操作',
            cnTitleId: 'CaoZuo',
            width: 110,
            dataIndex: 'options',
            fixed: "right",
            render: (options, record, index) => (
                <DeatilIn id={record.remittanceId}>
                    <HoverIcon inactiveIcon="icon-xiangqing"
                               activeIcon="icon-xiangqing-1"></HoverIcon>
                </DeatilIn>
            ),
        },
    ];
}


export  {
    getColumns,getColumnsIn
};
